import { DocumentEditor } from "@/components/document-editor";
import { CustomDrawer } from "./custom-drawer";

/** Help drawer for the current page: the page's markdown docs, rendered. */
export function PageDocDrawer({
	title,
	doc,
	open,
	onClose,
}: {
	title: string;
	doc: string;
	open: boolean;
	onClose: () => void;
}) {
	return (
		<CustomDrawer title={title} size="large" open={open} onClose={onClose}>
			<DocumentEditor content={doc} viewMode="preview" readOnly />
		</CustomDrawer>
	);
}
